export const socialTypes = ['linkedin', 'xing'];
